<template>
  <div v-if="informations.whatsapp" class="whatsapp-button">
    <TooltipWidget tip="WhatsApp" left>
      <v-btn
        :class="{ 'rounded-pill px-6': !!informations.whatsapp_float }"
        color="#25D366"
        :href="link"
        target="_blank"
        :large="!!informations.whatsapp_float"
        :fab="!informations.whatsapp_float"
      >
        <v-icon
          :size="informations.whatsapp_float ? 22 : 29"
          color="white"
          :left="!!informations.whatsapp_float"
        >
          fab fa-whatsapp
        </v-icon>

        <div
          v-if="informations.whatsapp_float"
          class="white--text text-body-1 text-none font-weight-medium"
        >
          {{ informations.whatsapp_float }}
        </div>
      </v-btn>
    </TooltipWidget>
  </div>
</template>

<script>
import { getWhatsappLinkFromPhone } from "../../utils/getWhatsappLinkFromPhone";
import TooltipWidget from "./TooltipWidget.vue";

export default {
  computed: {
    informations() {
      return this.$rest("informations").item;
    },
    link() {
      return getWhatsappLinkFromPhone(this.informations.whatsapp);
    },
  },
  components: {
    TooltipWidget,
  },
};
</script>

<style>
.whatsapp-button {
  position: fixed;
  right: 16px;
  bottom: 16px;
  width: max-content;
  z-index: 9;
}
</style>
